package com.gsb.vyapar.bhagya.presentation.category.view

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.clickable
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.Categories
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.category.event.CategoriesViewUiEvents
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.offwhite
import com.gsb.vyapar.bhagya.theme.unfocussed
import com.gsb.vyapar.bhagya.util.ADD_URL
import com.gsb.vyapar.bhagya.util.value

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun AdminCategoriesView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        var selectedCategory by remember { mutableStateOf(Categories.D.Category()) }
        Column(Modifier.fillMaxSize()) {
            Toolbar("AdminCategoriesView")
            Row(modifier = Modifier.fillMaxWidth().weight(8.0f)) {
                LazyColumn(
                    modifier = Modifier.width(130.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    items(uiState.getCategories().getCategoriesList(), key = { it.id }) { category ->
                        Card(
                            modifier = Modifier.width(120.dp).height(120.dp),
                            shape = RoundedCornerShape(8.dp),
                            backgroundColor = if (selectedCategory.id == category.id) unfocussed else offwhite,
                        ) {
                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                verticalArrangement = Arrangement.Center,
                                modifier = Modifier.combinedClickable(
                                    onClick = { selectedCategory = category },
                                    onLongClick = { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditCategory(category))) })
                            ) {
                                SmoothImage(
                                    uiState.getImage(category.imageUrl),
                                    width = 50.dp,
                                    height = 50.dp
                                )
                                Text14RegularB(text = category.name, color = black)
                                Text14RegularB(text = category.id.toString(), color = black)
                            }
                        }
                        Spacer(Modifier.height(8.dp))
                    }
                    item {
                        Spacer(Modifier.height(8.dp))
                        SmoothImage(
                            uiState.getImage(ADD_URL.value()),
                            width = 50.dp,
                            height = 50.dp,
                            modifier = Modifier.clickable { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditCategory(null))) }
                        )
                        Spacer(Modifier.height(8.dp))
                    }
                }
                LazyColumn(modifier = Modifier.fillMaxWidth().padding(8.dp)) {
                    items(selectedCategory.getSubCategoriesList(uiState.getSubCategories()), key = { it.id }) { subCategory ->
                        Card(
                            modifier = Modifier.fillMaxWidth().height(50.dp).clickable { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditSubCategory(subCategory))) },
                            shape = RoundedCornerShape(8.dp),
                            backgroundColor = offwhite,
                        ) {
                            Box(contentAlignment = Alignment.Center) {
                                Text14RegularB(text = subCategory.name, color = black)
                            }
                        }
                        Spacer(Modifier.height(8.dp))
                    }
                    item {
                        Spacer(Modifier.height(8.dp))
                        GVBButton(text = "Add SubCategory", onClick = { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditSubCategory(null))) })
                        Spacer(Modifier.height(8.dp))
                    }
                }
            }
            Column(Modifier.weight(2.0f), verticalArrangement = Arrangement.Center) {
                GVBButton(
                    text = "Save Categories",
                    onClick = { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.SaveCategories)) })
                Spacer(Modifier.height(16.dp))
                GVBButton(
                    text = "Save SubCategories",
                    onClick = { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.SaveSubCategories)) })
            }
        }
    }
}
